import React from 'react'
import ReactLoading from 'react-loading';
import LoadingOverlay from 'react-loading-overlay';
import { Paper } from "@material-ui/core";
import TableView from "utils/Table/TableView";

export default function DefaultTable(props) {
    return props.loading === undefined ? (
        <Paper>
            <TableView
                style={props.style}
                fixedColumns={props.fixedColumns}
                headers={props.headers}
                rows={props.rows}
                footers={props.footers}
            />
        </Paper>
    ) : (
        <LoadingOverlay
            active={props.loading}
            styles={{ overlay: (base) => ({ ...base, position: "absolute!important" }) }}
            spinner={<ReactLoading type={'spin'} height={50} width={50} />}
        >
            <Paper>
                <TableView
                    style={props.style}
                    fixedColumns={props.fixedColumns}
                    headers={props.headers}
                    rows={props.rows}
                    footers={props.footers}
                />
            </Paper>
        </LoadingOverlay>
    );
};
